import { HEADER } from '#/utils/navigationHelper';

const getItem = id => {
  const item = document.getElementById(id);

  // The id reported for the see all button sometimes is different
  // being something like id-1234-VIDEO-6 instead of id-1234-see-all and
  // the code below tries to grab the see all button based on that
  if (!item) {
    if (!(typeof id === 'object')) {
      const seeAllId = `${id
        .toString()
        .substr(0, id.lastIndexOf('VIDEO'))}see-all`;
      return document.getElementById(seeAllId);
    }
  }

  return item;
};

export const isItemOutsideScreen = id => {
  const item = getItem(id);

  if (!item) {
    return false;
  }
  const tvHeaderWidth =
    document.getElementById(HEADER.CONTAINER)?.firstChild.offsetWidth || 0;

  const { left, right } = item.getBoundingClientRect();
  const { innerWidth } = window;
  const { clientWidth } = document?.documentElement;

  if (left < tvHeaderWidth || right > (innerWidth || clientWidth)) {
    return true;
  }
  return false;
};

export const isItemOffScreenLeft = id => {
  const item = getItem(id);

  if (!item) {
    return false;
  }
  const tvHeaderWidth =
    document.getElementById(HEADER.CONTAINER)?.firstChild.offsetWidth || 0;

  const { left } = item.getBoundingClientRect();

  return left < tvHeaderWidth;
};

export const isItemOffScreenRight = id => {
  const item = getItem(id);

  if (!item) {
    return false;
  }

  const { right } = item.getBoundingClientRect();
  const { innerWidth } = window;
  const { clientWidth } = document?.documentElement;

  return right > (innerWidth || clientWidth);
};
